<div *ngIf="shortlistedProfiles?.length > 0 " id="topShortlist">
  <div class="more-ai-matched-card" *ngIf="projectDetails?.shortlistedreevaluationstatus == 'pending'">
    <p> <i class="fa-solid fa-arrows-rotate"></i><span class="font-weight-500">Autopilot<sup style="top: -1px !important;"><span>AI</span></sup> Evaluation Criteria updated.</span>  Click ‘Re-evaluate’ to apply updated Autopilot<sup style="top: -1px !important;"><span>AI</span></sup> Evaluation criteria</p>
    <button data-testid="auto-app-ai-sourcing-shortlist-button-1" class="btn-get-more-candidate active" [ngClass]="{'disabled': projectDetails?.status == 'inactive'}" [disabled]="projectDetails?.status == 'inactive'" (click)="projectDetails?.shortlistedreevaluationstatus == 'pending' && reEvaluateCriteria()"
        [matTooltip]="projectDetails?.status == 'inactive' ? 'Access limited to Shortlist. Increase project slot or Activate Project to view all tabs' : ''"
  matTooltipClass="red-tooltip text-black">Re-evaluate</button>
  </div>
  <div class="more-ai-matched-card" *ngIf="projectDetails?.shortlistedreevaluationstatus == 'started'">
    <p> <i class="fa-solid fa-circle-notch"></i><span class="font-weight-500">Autopilot<sup style="top: -1px !important;"><span>AI</span></sup> Re-evaluation in progress.</span>
      You'll receive an email once complete</p>
    <button data-testid="auto-app-ai-sourcing-shortlist-button-2" class="btn-get-more-candidate">Re-evaluate</button>
  </div>
</div>

<div class="wccard d-flex flex-column justify-content-center align-items-center"
  *ngIf="shortlistedProfiles?.length == 0 && !showLoaderbeforeDataLoad" style="height: 470px;">
  <div class="text-center">
    <p class="f-14 font-weight-500 mb-0 text-center">No shortlisted candidates yet.</p>
    <p class="f-14 font-weight-500 text-9696 text-center mt-1">Please shortlist a candidate from <b>To Review</b> - View Contact details for free and more actions.</p>
    <img src="../../../assets/ai-sourcing/shortlist-candidate.gif" alt="img-fluid" class="img-config">
  </div>
</div>

<div *ngIf="shortlistedProfiles?.length > 0 && !showLoaderbeforeDataLoad">
  <div *ngFor="let candidate of shortlistedProfiles; let i = index">
    <app-ai-sourcing-profile-card [data]="candidate" [selectedCandididate]="selectedCandididate" [index]="i" (childEvents)="eventHandler($event)"
      [calledfrompage]="'shortlistpage'">
      <div talentPoolBulkGrab>
        <label class="wc-checkbox mr-3">
          <input data-testid="auto-app-ai-sourcing-shortlist-input-1" [checked]="candidate.selected" [(ngModel)]="candidate.selected"
            (change)="selectCandidate($event, candidate)" type="checkbox" id="mycheck" name="mycheck">
          <i class="fas fa-check"></i>
        </label>
      </div>
    </app-ai-sourcing-profile-card>
  </div>
</div>

<div class="h-50 justify-content-center d-flex flex-column" *ngIf="showLoaderbeforeDataLoad">
  <div *ngFor="let i of [1,2,3,4,5]">
    <app-ai-sourcing-profile-skeleton></app-ai-sourcing-profile-skeleton>
  </div>
</div>

<div class="new-card d-flex justify-content-center wccard align-items-center" *ngIf="shortlistedProfiles?.length > 0">
  <ngb-pagination [collectionSize]="totalCandidatesCount" [maxSize]="5" [pageSize]="20" [rotate]="true"
    (pageChange)="setPage($event)" [(page)]="currentPage">
    <ng-template ngbPaginationPrevious> <span *ngIf="shortlistedProfiles?.length">
      Prev
    </span>
    </ng-template>
    <ng-template ngbPaginationNext>
      <span *ngIf="shortlistedProfiles?.length">Next</span> </ng-template>
  </ngb-pagination>
</div>


<div class="row justify-content-start">
  <div id="overlay" (click)="closeNav()">
  </div>
</div>

<div id="quickView">
  <div class="pr-3" *ngIf="showCandidate">
    <app-person-search-candidate-slider [data]="currentCandidate" [viewMoreSkills]="viewMoreSkills"
      [highlightkeywords]="highlightkeywords" [tabType]="tabType" (childEvents)="eventHandler($event)"
      (handleOutputEvent)="eventHandler($event)" [currentIndex]="currentIndex" [calledfrompage]="'shortlistpage'">
      <div shortlist class="pb-2">
        <div class="d-flex">
          <button data-testid="auto-app-ai-sourcing-shortlist-button-3" class="btn-trms-regular archive" style="width: 50%;"
            (click)="changeCandidateStatus(currentCandidate, 'archive')">
            <i class="fa-solid fa-user-minus"></i> Archive
          </button>
          <button data-testid="auto-app-ai-sourcing-shortlist-button-4" class="ml-2 btn-trms-regular px-0" (click)="openAddToEmailCampaign()" style="width: 50%;">
            <i class="fa-solid fa-envelopes-bulk mr-1"></i>Add to Email Campaign
          </button>

        </div>
      </div>

    </app-person-search-candidate-slider>
  </div>
</div>
<ng-template #addCandidateToEmailCampaign>
  <div class="modal-header b pb-0">
    <h5 class="f-14 font-weight-600" id="experience">Add Candidate to Email Campaign</h5>
    <button data-testid="auto-app-ai-sourcing-shortlist-button-5" type="button" class="close font-weight-normal ms-auto btn p-0 f-20"  data-dismiss="modal" aria-label="Close"
      (click)="closeActiveModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pb-3 pt-0">
    <div class="row mb-2 mt-2">
      <div class="col">
        <input data-testid="auto-app-ai-sourcing-shortlist-input-2" type="text" name="campaign_name" class="wc-form-control no-shadow w-100 inputheight mb-2"
          placeholder="Enter Campaign Name...." [formControl]="campaign_input" [matAutocomplete]="campaign_name"
          (input)="onTypeAheadSearch($event.target.value)" (click)="onTypeAheadSearch($event.target.value)" />
        <p *ngIf="campaign_input.errors?.required && (campaign_input.dirty || campaign_input.touched)"
          class="f-12 text-danger">Campaign Name is required</p>
        <mat-autocomplete #campaign_name="matAutocomplete" (optionSelected)="onCampaignSelected($event.option.value)">
          <mat-option *ngFor="let campaign of campaignList" [value]="campaign" [disabled]="campaign.remaining_targets <= 0">
            <div class="d-flex justify-content-between align-items-center">
              <span>{{ campaign.campaign_name }}</span> <span class="badge badge-light border f-12 font-weight-normal text-9696" *ngIf="campaign.remaining_targets <= 0">Campaign limits reached</span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
    <div class="row mb-0">
      <div class="col d-flex justify-content-end">
     <button data-testid="auto-app-ai-sourcing-shortlist-button-6" class="btn-trms-small" (click)="!isLoadingEmailCampaignApi && addToEmailCampaign()"
          [disabled]="!campaign_input.valid && isLoadingEmailCampaignApi" >
             <span [ngClass]="{ 'spinner-border spinner-size': isLoadingEmailCampaignApi }"
            [ngStyle]="{ 'width: 20px; height: 20px;': isLoadingEmailCampaignApi }">
            {{isLoadingEmailCampaignApi ? '' : 'Add'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

